
const Table = {
	baseStyle: {
	},
	variants: {
		// a low-key table
		simple: {
			table: {				
			},
			td: {			
				fontWeight: "normal"
			},
			th: {
				color: "gray.800",
				fontWeight: "normal",
				textTransform: "none"
			}
		}
	}
  };
  
export default Table;